/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Course_Deletenodedesc2Inputs */

const zh_course_deletenodedesc2 = /** @type {(inputs: Course_Deletenodedesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`删除此节点将同时删除其所有子节点。已关联的学习资源不会被删除。`)
};

const en_course_deletenodedesc2 = /** @type {(inputs: Course_Deletenodedesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deleting this node will also remove all its children. Linked study resources will not be deleted.`)
};

const es_course_deletenodedesc2 = /** @type {(inputs: Course_Deletenodedesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar este nodo también eliminará todos sus hijos. Los recursos vinculados no se eliminarán.`)
};

/**
* | output |
* | --- |
* | "Deleting this node will also remove all its children. Linked study resources will not be deleted." |
*
* @param {Course_Deletenodedesc2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const course_deletenodedesc2 = /** @type {((inputs?: Course_Deletenodedesc2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Course_Deletenodedesc2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_course_deletenodedesc2(inputs)
	if (locale === "en") return en_course_deletenodedesc2(inputs)
	return es_course_deletenodedesc2(inputs)
});
export { course_deletenodedesc2 as "course_deleteNodeDesc" }